import React, { createContext, useContext } from 'react';

import { useTrendAdminController } from './useTrendAdminController';

export type TrendAdminController = ReturnType<typeof useTrendAdminController>;

const TrendAdminContext = createContext<TrendAdminController | null>(null);

type TrendAdminProviderProps = {
  canAdmin: boolean;
  canReview?: boolean;
  canManageSources?: boolean;
  navigateToView?: (view: 'overview' | 'editorial') => void;
  children: React.ReactNode;
};

export function TrendAdminProvider({
  canAdmin,
  canReview = false,
  canManageSources = true,
  navigateToView,
  children,
}: TrendAdminProviderProps) {
  const controller = useTrendAdminController(canAdmin, canReview, canManageSources, navigateToView);
  return (
    <TrendAdminContext.Provider value={controller}>
      {children}
    </TrendAdminContext.Provider>
  );
}

export function useTrendAdmin(): TrendAdminController {
  const context = useContext(TrendAdminContext);
  if (!context) {
    throw new Error('useTrendAdmin måste användas inom en TrendAdminProvider.');
  }
  return context;
}
